import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import GoogleAssetGroupForm from './GoogleAssetGroupForm'
import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'

import useClearAssetsGroupCreate from './hook'

import { closeForm } from '../../../../../modules/actions/forms'

import { ASSET_GROUP_GOOGLE_ADS_CREATE } from '../../../../../constants/forms'

// If google ads campaign type = performance max (identified by AdvertisingChannelType = 10 ) then: () =>
// Campaign will have no line items and will only have a list of ads, and the ads are different (not visuals, but asset groups)
const GoogleAssetGroupCreate = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const clearCreateAssetsGroupHandler = useClearAssetsGroupCreate()

  const onAfterFormClose = useCallback(() => {
    clearCreateAssetsGroupHandler()
  }, [clearCreateAssetsGroupHandler])

  const onSuccessSubmit = useCallback(() => {
    dispatch(closeForm())
  }, [dispatch])

  return (
    <FormDrawerWrapper
      openButtonText={t('Create ad')}
      formName={ASSET_GROUP_GOOGLE_ADS_CREATE}
      closeOnSubmit={false}
      onAfterFormClose={onAfterFormClose}
    >
      <GoogleAssetGroupForm onSuccessSubmit={onSuccessSubmit} />
    </FormDrawerWrapper>
  )
}

export default GoogleAssetGroupCreate
